import { Button as OLXButton } from '@olxbr/design-system';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentTextMUI from '@material-ui/core/DialogContentText';
import DialogTitleMUI from '@material-ui/core/DialogTitle';
import styled from 'styled-components';

type Props = {
  children?: any;
  nextButtonLabel?: string;
  backButtonLabel?: string;
  nextButton: Function;
  backButton: Function;
  visible?: boolean;
  title: string;
};

const DialogTitle = styled(DialogTitleMUI)`
  font-size: 20px;
  line-height: 20px;
  color: #4a4a4a;
  font-weight: 600;
  font-family: ‘Nunito Sans’, sans-serif;
  @media only screen and (max-width: 600px) {
    padding 0;
  }
`;

const Button = styled(OLXButton)`
  grid-column: 3;
  margin: 0 !important;
  @media only screen and (max-width: 320px) {
  }
`;

const DialogContentText = styled(DialogContentTextMUI)``;

const BackButton = styled(Button)`
  color: #6e0ad6;
  border-color: transparent;
  padding: 0;
  display: block;
  max-width: max-content;
  min-width: 0px;
  border: 0;
  grid-column: 1;
  :hover {
    text-decoration: underline;
    background-color: unset;
  }
`;

const Dialog = styled(DialogMUI)`
  * {
    font-family: ‘Nunito Sans’, sans-serif !important;
  }
  .MuiDialog-paper {
    width: 300px;
    padding: 32px;
    padding-top: 25px;
    @media only screen and (max-width: 600px) {
      padding: 32px 24px;
      min-height: 0;
    }
  }
  .MuiDialogTitle-root,
  .MuiTypography-h6 {
    padding: 0;
    @media only screen and (max-width: 600px) {
      letter-spacing: 0;
      font-family: ‘Nunito Sans’, sans-serif;
      line-height: 28px;
    }
  }
  .MuiDialogContent-root {
    padding: 0;
    margin-bottom: 32px;
    margin-top: 6px;
    @media only screen and (max-width: 600px) {
      margin-top: 8px;
      margin-bottom: 20px;
    }
    * {
      color: #4a4a4a;
    }
  }
  .MuiDialogActions-root {
    place-self: flex-end;
    padding: 0;
    grid-auto-flow: column;
    grid-template-columns: auto 24px auto;
    display: grid;
    @media only screen (max-width: 320) {
      grid-template-columns: 46% 8% 46%;
      place-self: center;
    }
  }
`;

const Modal = (props: Props) => {
  const {
    children,
    nextButtonLabel,
    backButtonLabel,
    visible,
    backButton,
    nextButton,
    title,
  } = props;

  return (
    <>
      {/* @ts-ignore */}
      <Dialog
        open={visible}
        onClose={backButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        {title ? (
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        ) : (
          ''
        )}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <BackButton onClick={backButton} outline>
            {backButtonLabel}
          </BackButton>
          <Button onClick={nextButton}>{nextButtonLabel}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

Modal.defaultProps = {
  visible: false,
  backButtonLabel: 'Não',
  nextButtonLabel: 'Sim',
};

export default Modal;
